import React from 'react'
import PropTypes from 'prop-types'
import {Checkbox} from 'antd'
import {FLOORS} from 'lib/enumMapping'
import QuantityField from './QuantityField'

class FloorPlansProduct extends React.Component {
  static propTypes = {
    product: PropTypes.object.isRequired,
    webOrder: PropTypes.object.isRequired,
    bundleProduct: PropTypes.object,
    onChange: PropTypes.func,
    style: PropTypes.object,
  }

  componentDidMount() {
    this.props.onChange({floors: this.numberOfEstateFloors})
  }

  get errorText() {
    if (this.estateFloors && this.props.product.floors !== this.numberOfEstateFloors) {
      return `Eiendommen har ${this.numberOfEstateFloors} plan.`
    }
    return null
  }

  // Since we uses characters to define the amount of floors, where for instance "a" is 1, and
  // "d" is "4+", we need an integer here that will be inserted as default for the number
  // of floors to order.
  get numberOfEstateFloors() {
    if (FLOORS[this.estateFloors]) {
      // We know FLOORS only contain values parseInt will accept
      return parseInt(FLOORS[this.estateFloors], 10)
    }
    return 1
  }

  // Floors can be defined on either an existing estate the web order is
  // based on, or on the web order itself if there is no existing estate.
  get estateFloors() {
    const {webOrder} = this.props
    return webOrder.estate && webOrder.estate.floors
      ? webOrder.estate.floors
      : webOrder.floors
  }

  render() {
    const floors = this.props.product.floors || this.numberOfEstateFloors

    return (
      <>
        <div>
          <span>Antall plan</span>
          <QuantityField
            value={floors}
            onChange={value => this.props.onChange({floors: value})}
          />
          {!!this.errorText && <span>{this.errorText}</span>}
        </div>

        {'measurement' in this.props.product && (
          <Checkbox
            checked={this.props.product.measurement}
            disabled={!!this.props.bundleProduct}
            onChange={e => this.props.onChange({measurement: e.target.checked})}
          >
            Jeg ønsker også oppmåling
          </Checkbox>
        )}
      </>
    )
  }
}

export default FloorPlansProduct
